import * as ActionTypes from '../constants/ActionTypes';

const initialState = {
	tickets: [],
	loadingTickets: false
};

export default function purchaseHistoryPageReducer(state = initialState, action) {
	switch (action.type) {
		case ActionTypes.GET_PURCHASE_HISTORY_PAGE_REQUEST:
		case ActionTypes.GET_PURCHASE_HISTORY_PAGE_ERROR:
		case ActionTypes.GET_PURCHASE_HISTORY_PAGE_SUCCESS:
			return {
				...state,
				...action.payload
			};
		case ActionTypes.RESET_PURCHASE_HISTORY_PAGE_META:
			return {
				...state,
				meta: null
			};
		case ActionTypes.RESET_PURCHASE_HISTORY_PAGE:
			return {
				...initialState
			};
		default:
			return state;
	}
}
